import { IconButton } from '@material-ui/core'
import { SwapHoriz } from '@material-ui/icons'

import { useCompareDiagnoses } from '../../contexts/compare-diagnoses-context'
import { useStyles } from './styles'

export const SwapButton = () => {
  const classes = useStyles()
  const {
    baseDiagnosisId,
    compareDiagnosisId,
    setBaseDiagnosisId,
    setCompareDiagnosisId,
  } = useCompareDiagnoses()

  const handleSwap = () => {
    setBaseDiagnosisId(compareDiagnosisId)
    setCompareDiagnosisId(baseDiagnosisId)
  }

  const isDisabled = !baseDiagnosisId || !compareDiagnosisId

  return (
    <IconButton
      className={classes.swapButton}
      onClick={handleSwap}
      disabled={isDisabled}
      size='medium'
      aria-label='Inverter seleções dos mapas'
    >
      <SwapHoriz />
    </IconButton>
  )
}
